import React, { createContext, useCallback, useContext, useState } from "react"

interface FilterBarExtensionContextValue {
  extraChips: React.ReactNode
  replaceStandardFilters: boolean
  setExtraChips: (chips: React.ReactNode, replace?: boolean) => void
  clearExtraChips: () => void
}

const FilterBarExtensionContext = createContext<FilterBarExtensionContextValue>({
  extraChips: null,
  replaceStandardFilters: false,
  setExtraChips: () => {},
  clearExtraChips: () => {}
})

export const FilterBarExtensionProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [extraChips, setExtraChipsState] = useState<React.ReactNode>(null)
  const [replaceStandardFilters, setReplaceStandardFilters] =
    useState<boolean>(false)

  const setExtraChips = useCallback(
    (chips: React.ReactNode, replace = false) => {
      setExtraChipsState(chips)
      setReplaceStandardFilters(replace)
    },
    []
  )

  const clearExtraChips = useCallback(() => {
    setExtraChipsState(null)
    setReplaceStandardFilters(false)
  }, [])

  return (
    <FilterBarExtensionContext.Provider
      value={{ extraChips, replaceStandardFilters, setExtraChips, clearExtraChips }}
    >
      {children}
    </FilterBarExtensionContext.Provider>
  )
}

export const useFilterBarExtension = () =>
  useContext(FilterBarExtensionContext)

export default FilterBarExtensionContext
